<template lang="pug">
  b-modal#checkMemberFreeSpin(
  ref="checkMemberFreeSpin"
  :title="$t('ui.combine.check_free_spin')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.account_id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="accountId"
          required
          alphaNum
          type="text"
          :dirty="$v.accountId.$dirty"
          :error="$v.accountId.$error"
          v-model.trim.lazy="$v.accountId.$model"
          :disabled="loading"
          :maxLength="$v.accountId.$params.maxLength.max"
        )
        ValidateResult(:value="$v.accountId" :name="$t('ui.account_id')")
      b-form-group(:label="$t('ui.provider')").mb-0
        b-form-select(
          :dirty="$v.provider.$dirty"
          :error="$v.provider.$error"
          v-model.trim.lazy="$v.provider.$model"
          :disabled="loading"
          size="sm"
          @change="checkMemberFreeSpin($event)"
        )
          option(value="" disabled selected) {{ $t("message.select_option") }}
          option(value="EPIC2") EPIC2
          //- option(value="MEGAH5") MEGAH5
      ValidateResult(:value="$v.provider" :name="$t('ui.provider')")
      b-form-group(:label="$t('ui.result')" disabled).mb-3
        b-form-textarea(v-model="responseJson" rows="15")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, minLength, maxLength, alphaNum, integer, email, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      accountId: "",
      responseJson: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      provider: ""
    };
  },
  computed: {
  },
  validations: {
    accountId: {
      required,
      // minLength: minLength(6),
      maxLength: maxLength(20)
    },
    provider: {
      required
    }
  },
  methods: {
    checkMemberFreeSpin: function(code) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = "";
        
        if (this.provider == 'EPIC2')
          url = config.epic2GetFreeRoundUrl();
        else if (this.provider == 'MEGAH5')
          url = config.megah5GetFreeRoundUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          member_id: this.item.account_id
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  var obj = response.data.dt
                  this.responseJson = JSON.stringify(obj, undefined, 4);
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.accountId = this.item.account_id;
      this.responseJson = "";
      this.provider = "";
      //this.checkMemberFreeSpin();
    }
  }
};
</script>
